import React from "react";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { CURRENT_VERSION } from "../../version";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const textColor = useColorModeValue("gray.500", "white");
  const { t } = useTranslation();

  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems="center"
      justifyContent="center"
      w="100%"
      px="30px"
      pb="20px"
      pt="20px"
    >
      <Text
        color={textColor}
        textAlign="center"
        fontSize="sm"
      >
        {t("footerText", { version: CURRENT_VERSION })}
      </Text>
    </Flex>
  );
}
